import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './app/store';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import App from './App';
import {initAmplitude} from './analytics/amplitude';
import {initGismart} from './analytics/gismart';
import { initLockerStudio } from './analytics/lockerStudio';
import Cookies from 'js-cookie';


const initCallback = analytics => {
    window.sessionStorage?.setItem(analytics+'Init','true');
};

initAmplitude(null,initCallback);

let checkCookies = setInterval(
    () => {
        let id = Cookies.get('userUuid');
        if (id) {
            initGismart(id,initCallback);
            initLockerStudio(id, initCallback);
            clearInterval(checkCookies);
        }
    },
    500
);

let persistor = persistStore(store);


ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    </React.StrictMode>
    , document.getElementById('app'));
